var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8People50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA726",
    d: "M12 16A5 5 0 1 0 12 26A5 5 0 1 0 12 16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M2 34.7c0 0 2.8-6.3 10-6.3s10 6.3 10 6.3V38H2V34.7zM46 34.7c0 0-2.8-6.3-10-6.3s-10 6.3-10 6.3V38h20V34.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74D",
    d: "M24 11A6 6 0 1 0 24 23A6 6 0 1 0 24 11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#607D8B",
    d: "M36,34.1c0,0-3.3-7.5-12-7.5s-12,7.5-12,7.5V38h24V34.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA726",
    d: "M36 16A5 5 0 1 0 36 26A5 5 0 1 0 36 16Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA726",
    d: "M12 16A5 5 0 1 0 12 26 5 5 0 1 0 12 16zM36 16A5 5 0 1 0 36 26 5 5 0 1 0 36 16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8People50);
export default __webpack_public_path__ + "static/media/icons8-people-50.9639bf53c2748c704b65cca8d86fd558.svg";
export { ForwardRef as ReactComponent };